<template>
  <div id="QualityCoatedDataIterator">
    <v-card tile outlined>
      <v-toolbar flat color="grey lighten-4" dense>
        <v-toolbar-title><v-icon left>note</v-icon>Notes</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        {{ ticket.notes }}
      </v-card-text>
    </v-card>
    <v-data-iterator :items="ticket.rawmaterials" hide-default-footer>
      <template v-slot:default="props">
        <v-row justify="center" v-for="item in props.items" :key="item.id">
          <v-col cols="12">
            <QualityRawMeasurementWrapper
              :rawid="parseInt(item.id)"
            />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import QualityRawMeasurementWrapper from "../../components/Quality/QualityRawMeasurementWrapper";
export default {
  name: "QualityRawData",
  components: { QualityRawMeasurementWrapper },
  props: {
    ticket: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
